export default __webpack_public_path__ + "static/media/iconUser.142424b8.svg";